import NormalBookingComponent from '../components/Booking/NormalBooking';
import DrawBookingComponent from '../components/Booking/DrawBooking';
import HistoryComponent from '../components/Booking/History';
import ReviewComponent from '../components/Review';
import SettingComponent from '../components/Setting/';
import DrawResultComponent from '../components/Booking/DrawResult';
import ManageComponent from '../components/Manage/';
import ForbiddenComponent from '../components/Exceptions/403';
import NoFoundComponent from '../components/Exceptions/404';
import ErrorComponent from '../components/Exceptions/500';
import LoginComponent from '../components/Login';
import NewsComponent from '../components/News';
import VueRouter from 'vue-router'
import store from '../store';
import {getAuth, setAuth} from '../services/auth';
import jwt from 'jsonwebtoken';

export const routeDefs = [
    {
        path: '/',
        redirect: '/news',
    },
    {
        title: '公告',
        show: true,
        claims: ['user', 'teacher'],
        path: '/news',
        name: 'news',
        exact: true,
        component: NewsComponent
    },
    {
        title: '場地借用',
        show: true,
        claims: ['user', 'teacher'],
        path: '/booking',
        name: 'booking',
        redirect: '/booking/normal',
        exact: true,
    },
    {
        title: '一般場地借用',
        show: true,
        inSubMenu: true,
        parent: 'booking',
        claims: ['user', 'teacher'],
        path: '/booking/normal',
        component: NormalBookingComponent,
        name: 'booking/normal',
        exact: true,
    },
    {
        title: '夜間抽籤場地(籃球場、排球場...)登記',
        show: true,
        inSubMenu: true,
        parent: 'booking',
        claims: ['user'],
        path: '/booking/draw',
        component: DrawBookingComponent,
        name: 'booking/draw',
        exact: true,
    },
    {
        title: '申請紀錄',
        show: true,
        claims: ['user'],
        path: '/booking/history',
        inSubMenu: true,
        parent: 'booking',
        component: HistoryComponent,
        name: 'history',
        exact: true
    },
    {
        title: '抽籤結果',
        show: true,
        inSubMenu: true,
        parent: 'booking',
        claims: ['user'],
        path: '/booking/drawResult',
        component: DrawResultComponent,
        name: '/booking/drawResult',
        exact: true,
    },
    {
        title: '申請審查',
        show: true,
        claims: ['admin'],
        path: '/review',
        component: ReviewComponent,
        name: 'review',
        exact: true
    },
    {
        title: '管理',
        show: true,
        claims: ['super'],
        path: '/manage',
        component: ManageComponent,
        name: 'manage',
        exact: true
    },
    {
        title: '系統設定',
        show: true,
        claims: ['super'],
        path: '/setting',
        component: SettingComponent,
        name: 'setting',
        exact: true
    },
    {
        claims: [],
        path: '/login',
        component: LoginComponent,
        name: 'login'
    },
    {
        claims: [],
        path: '/403',
        component: ForbiddenComponent,
        name: 'forbidden'
    },
    {
        claims: [],
        path: '/404',
        component: NoFoundComponent,
        name: 'noFound'
    },
    {
        claims: [],
        path: '/500',
        component: ErrorComponent,
        name: 'error'
    },
    {
        path: '/sso',
        name:'sso'
    },
    {
        path: '*'
    }
];

const router = new VueRouter({
    mode: 'history',
    routes: routeDefs,
    base: process.env.VUE_APP_IS_STAGING === 'true' ? '/pebooking/' : '/'
});

router.beforeEach((to, from, next) => {
    const {path} = to.matched[0];
    if (path === '*') {
        next({name: 'noFound'});
    } else if (to.name === 'sso') {
        const {t} = to.query;
        if(t){
            try {
                setAuth(window.atob(t));
                next('/');
            } catch {
                next({name: 'forbidden'});
            }
        } else{
            next({name: 'forbidden'});
        }
    } else {
        const {name} = to;
        const {claims} = getAuth();
        const authenticated = claims.length > 0;
        if (name === 'login') {
            if (authenticated) {
                next('/');
            } else {
                next();
            }
        } else {
            const def = routeDefs.find(r => r.name === name);
            if (authenticated || !def || def.claims.length <= 0) {
                if (def && def.claims.length > 0) {
                    //代表這個路徑允許這個登入者
                    if (def.claims.some(c => claims.some(cc => cc === c))) {
                        next();
                    } else {
                        store.commit('resetLoading');
                        //未授權
                        next({name: 'forbidden'})
                    }
                } else {
                    //不需要驗證的位址
                    if (def.name === 'forbidden' || def.name === 'error' || def.name === 'noFound') {
                        store.commit('resetLoading');
                    }
                    next();
                }

            } else {
                next({name: 'login', query: {redirect: name}});
            }
        }

    }

});

export default router;